<template>
  <span>
    <span
      style="cursor: pointer;"
      @click="handleClick"
      class="incognito"
      v-text="text"
    ></span>
  </span>
</template>

<script>
export default {
  name: "QuizPlaceholder",
  props: ["index", "text"],
  data() {
    return {};
  },
  mounted() {},

  computed: {},
  methods: {
    handleClick(event) {
      this.$emit("placeholderClick", event);
    }
  },

  components: {}
};
</script>

<style lang="scss" scoped>
.incognito {
  font-size: 1rem;
  color: white;
  background-color: grey;
  padding: 3px 8px;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 5px;
  white-space: nowrap;
}
</style>
